
<div class="wrapper">
  <!--===================== Header ========================-->
  <app-header></app-header>
  <div>
    <router-outlet>

    </router-outlet>
  </div>
  <!--===================== End of Header ========================-->
  <!--===================== Base Slider ========================-->

  <app-footer></app-footer>
  <!--===================== End of Footer ========================-->
</div><!--wrapper-->
